module.exports = __webpack_public_path__ + "img/icon_visit_registration_calendar_hover.c1a31f14.svg";